import Card from "@mui/material/Card";
import "./component.css";
import Box from "@mui/material/Box";
const DataCard: React.FC<{ children?: React.ReactNode, minHeight ?: string|number }> = ({ children, minHeight }) => {
  const gradient = `radial-gradient(
    123.49% 96.92% at 3.14% 0%,
    #6F16FF 0%,
    rgba(0,0,0,0) 100%
  )`;

  return (
    <Box
      sx={{
        display: "inline-block",
        borderRadius: "25px",
        backgroundImage: gradient,
        p: "2px",
        maxWidth: "100%",
        width: "100%",
        overflow: "visible"
      }}
    >
      <Card
        elevation={0}
        sx={{
          backgroundColor: "#010101",
          borderRadius: "20px",
          // minWidth: 400,
          minHeight:minHeight || 400,
          position: "relative",
          // overflow: "hidden",
        }}
      >
        <div className="datacard-bg-purple"></div>
        <div className="datacard-bg-black"></div>
        <Box sx={{ zIndex: 999, position: "relative", p: 3 , maxHeight :"500px", }}>{children}</Box>
      </Card>
    </Box>
  );
};

export default DataCard;
